package one.healthium.pcos

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.Features
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

internal fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://pcos-content-stage.web.app/"
                Flavour.Prod -> "https://pcos-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "PCOS",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> "0ddda39b19fb9227bbdbb5395bcf066d"
            Flavour.Prod -> "51d602d3944df7cc051fc8fb1e4d4e51"
        },
        adaptyKey = "public_live_M5S3azoe.xDrhdDla3pmgBodAEwJU",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6739416655",
        feedbackEmail = "pcos@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:452372911419:android:967ba53181a25271a9531e",
                apiKey = "AIzaSyCoizW0j0u60VxXbLb_uKt5o6pwLacs2hc",
                projectId = "pcos-app-stage",
                storageBucket = "pcos-app-stage.firebasestorage.app",
                userStorageBucket = "gs://pcos-app-stage-users-data",
                authDomain = "pcos-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:8586911906:android:43fb3f19489a8d9e07b7fb",
                apiKey = "AIzaSyCimPKpYleYbXKN4sA_LzJIl7x1UgN0FDY",
                projectId = "pcos-app-prod",
                storageBucket = "pcos-app-prod.firebasestorage.app",
                userStorageBucket = "gs://pcos-app-prod-users-data",
                authDomain = "pcos-app-prod.firebaseapp.com",
            )
        },
        features = Features(
            periodTrackerEnabled = true,
        ),
        appId = when (flavour) {
            Flavour.Stage -> "pcos_stage"
            Flavour.Prod -> "pcos"
        },
        oneLinkBaseUrl = "https://hltm-pcos.onelink.me/InBr/web",
    )

